import type { JobQuote } from "../api/generated/model";

/** Live's hint on an approximate estimate (`uft-estimate`'s `APPROXIMATE_HINT`), word for word:
 * every source-length estimate (Daniil, 2026-10-21). */
export const APPROXIMATE_HINT =
  "Approximate generation cost. The final cost may be slightly different.";

/** "4 credits", "about 4 credits", "2 to 8 credits". */
export function creditsText({ credits_min, credits_max, approximate }: JobQuote): string {
  const about = approximate ? "about " : "";
  if (credits_min === credits_max) return `${about}${credits_max} credits`;
  return `${about}${credits_min} to ${credits_max} credits`;
}
